import { esc, openModal } from '../ui/modal';
import { t } from '../ui/lang';
import { fetchFarmClickerApps } from './clicker-apps-shared';
import { mountOperationsRegistry } from './clicker-operations-shared';
// Remembered rows-per-page for this table (the run-history popup keeps its own).
const PAGE_SIZE_KEY = 'mf.opsPageSize';
/**
 * Per-device operations registry in a big popup (same 90vw/90vh chrome as the clicker
 * log window). Shows every deposit/payout the clicker finalized on this device, with the
 * operator who was running it and per-operation Platform and Telegram sync flags.
 *
 * The table itself — toolbar, filters, columns, paging — is the shared registry
 * (clicker-operations-shared.ts), the same one the team-wide Dashboards tab mounts; this
 * file only supplies the popup chrome and the per-device endpoint. Registry is visible to
 * anyone who can reach the device (the server authorizes by device scope), so no role
 * gate here.
 */
export function openClickerOperationsWindow(farmId, udid, deviceName) {
    const title = deviceName ? `${deviceName}` : udid;
    const modal = openModal(`
        <h2 class="modal__title">${t('clickertab.ops_title')} — ${esc(title)}</h2>
        <div class="clicker-ops-mount"></div>
    `);
    modal.classList.add('modal--clicker-log', 'modal--clicker-ops');
    mountOperationsRegistry(modal.querySelector('.clicker-ops-mount'), {
        scope: 'device',
        pageSizeKey: PAGE_SIZE_KEY,
        endpoint: (params) => `/api/farms/${farmId}/clicker/devices/${encodeURIComponent(udid)}/operations?${params.toString()}`,
        loadApps: () => fetchFarmClickerApps(farmId),
    });
}
